'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const getById = require('./get-by-id.js');

const getValueText = (item) => item.dataset.valuetext ?? item.textContent ?? "";
const match = (valueText, query) => valueText.toLowerCase().startsWith(query.toLowerCase());
const wrap = (v, idx) => {
  return v.map((_, index) => v[(Math.max(idx, 0) + index) % v.length]);
};
function getByText(v, text, currentId) {
  const index = currentId ? getById.indexOfId(v, currentId) : -1;
  let items = currentId ? wrap(v, index) : v;
  const isSingleKey = text.length === 1;
  if (isSingleKey) {
    items = items.filter((item) => item.id !== currentId);
  }
  return items.find((item) => match(getValueText(item), text));
}

exports.getByText = getByText;
